import { log, supabase } from ".";

export const updateOportunidadBTL = async ({ id, oportunidad }) => {
  try {
    const data = await supabase.update("sales_btl", oportunidad, id);

    if (!data || data.length === 0) throw new Error("Empty response");

    return data;
  } catch (error) {
    log.error("updateOportunidad", error);
    throw error;
  }
};
